import { Model } from "pinia-orm";

export default class ActivityNature extends Model {
  static entity = "activityNatures";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      code: this.string(""),
      internalCode: this.string(""),
      label: this.string(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),
    };
  }
}
